import { Folder, User, BarChart3, FileText, Type, X } from "lucide-react"
import { TextWithCitations, type CitationSource } from "@/components/drafting/CitationBadge"
import type { ThemeEvidence } from "@/stores/strategy-store"

const evidenceIcons: Record<ThemeEvidence['type'], typeof Folder> = {
  project: Folder,
  personnel: User,
  statistic: BarChart3,
  library: FileText,
  freetext: Type,
}

interface WinThemeEvidenceListProps {
  evidence: ThemeEvidence[]
  onRemove?: (index: number) => void
  readOnly?: boolean
  sources?: CitationSource[]
  onNavigateToSource?: (source: CitationSource) => void
}

export function WinThemeEvidenceList({
  evidence,
  onRemove,
  readOnly = false,
  sources,
  onNavigateToSource,
}: WinThemeEvidenceListProps) {
  if (evidence.length === 0) return null

  const hasCitations = sources && sources.length > 0

  return (
    <div className="bg-muted/30 rounded-lg divide-y divide-border">
      {evidence.map((item, i) => {
        const Icon = evidenceIcons[item.type]
        return (
          <div key={i} className="flex items-center justify-between px-3 py-2.5 group">
            <div className="flex items-center gap-2.5 min-w-0">
              <Icon className="h-3.5 w-3.5 text-muted-foreground flex-shrink-0" />
              {hasCitations ? (
                <span className="text-xs min-w-0">
                  <TextWithCitations
                    text={item.detail}
                    sources={sources}
                    {...(onNavigateToSource && { onNavigateToSource })}
                  />
                </span>
              ) : (
                <span className="text-xs truncate">{item.detail}</span>
              )}
            </div>
            {!readOnly && onRemove && (
              <button
                type="button"
                onClick={() => onRemove(i)}
                className="opacity-0 group-hover:opacity-100 p-0.5 rounded hover:bg-muted transition-opacity flex-shrink-0"
              >
                <X className="h-3.5 w-3.5 text-muted-foreground" />
              </button>
            )}
          </div>
        )
      })}
    </div>
  )
}
